import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const EditParagraphContext = createContext(null);

export function EditParagraphProvider({ children, transcriptId }) {
  const [editingParagraphId, setEditingParagraphId] = useState(null);

  // Start editing a paragraph - just track which paragraph
  const startEdit = useCallback((paragraphId) => {
    setEditingParagraphId(paragraphId);
  }, []);

  // Cancel editing - clear the paragraph ID
  const cancelEdit = useCallback(() => {
    setEditingParagraphId(null);
  }, []);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      // State
      editingParagraphId,
      transcriptId,
      isEditing: editingParagraphId !== null,
      
      // Actions
      startEdit,
      cancelEdit,
    }),
    [editingParagraphId, transcriptId, startEdit, cancelEdit]
  );

  return (
    <EditParagraphContext.Provider value={contextValue}>
      {children}
    </EditParagraphContext.Provider>
  );
}

// Custom hook to use the EditParagraph context
export function useEditParagraph() {
  const context = useContext(EditParagraphContext);
  return context || {};
}